import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from './layout/AppHeader.jsx';

const NAV = [
  { to: '/admin', label: 'Organization', end: true },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/roles', label: 'Roles & Permissions' },
  { to: '/admin/supervisor-rules', label: 'Supervisor Rules' },
  { to: '/admin/tags', label: 'User Tags' },
  { to: '/admin/org-chart', label: 'Org Chart' },
  { to: '/admin/webhooks', label: 'Webhooks' },
  { to: '/admin/api-keys', label: 'API Keys' },
  { to: '/admin/integrations', label: 'Integrations' },
  { to: '/admin/audit', label: 'Audit Log' },
  { to: '/admin/health', label: 'System Health' },
];

export default function AdminShell() {
  return (
    <div className="hr-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Admin</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} end={n.end} className={({ isActive }) => isActive ? 'active' : ''}>{n.label}</NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main"><Outlet /></main>
      </div>
    </div>
  );
}
